

export class TourAddOutput implements ITourAddOutput {
    status!: number;
    message!: string;

    constructor(data?: ITourAddOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TourAddOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TourAddOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface ITourAddOutput {
    status: number;
    message: string;
}

